<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium"
            >{{ $t('ITEM.CREATE') }} {{ $t('APP_CONTENT.APP_CONTENT') }}</span
          >
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>

    <v-card v-if="error" tile class="mt-5">
      <v-alert
        v-for="(e, index) in error.data.errors"
        :key="index"
        tile
        color="error"
        dark
        dense
        >{{ e[0] }}
      </v-alert>
    </v-card>

    <v-card tile class="pa-5 mt-4">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="validate"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="localappcontent.title"
              :rules="rules.requiredTextLine65"
              :counter="65"
              outlined
              :label="`${$t('ITEM.TITLE')} *`"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-content-tabs
              v-model="localappcontent"
              form-path="modules/app_content/components/AppContentIframeForm.vue"
            ></app-content-tabs>
          </v-col>
        </v-row>
        <v-row class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            :disabled="
              !(
                !!localappcontent.translations &&
                languages.length === localappcontent.translations.length &&
                valid
              )
            "
            elevation="24"
            large
            color="success"
            >{{ $t('BUTTON.SAVE') }}</v-btn
          >
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { cloneDeep } from 'lodash';
import { requiredTextLine65 } from '@/modules/_global/variables/rules.js';

export default {
  name: 'AppContentEditPage',

  components: {
    AppContentTabs: () =>
      import('@/modules/app_content/components/AppContentTranslationTabs.vue')
  },

  data() {
    return {
      error: null,
      valid: true,
      localappcontent: {},
      copyLocalappcontent: null,
      appcontent: {},
      rules: {
        requiredTextLine65
      },
      languages: []
    };
  },

  created() {
    this.setData();

    this.$store
      .dispatch('localization/retrieveLanguages')
      .then(response => {
        this.languages = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('appcontent/storeIframe', this.localappcontent)
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
            this.$router.push({ name: 'appcontent' });
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    },

    setData() {
      this.localappcontent = cloneDeep(this.appcontent);
      this.copyLocalappcontent = cloneDeep(this.appcontent);
    }
  }
};
</script>
